var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSort = function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: ".8rem",
    height: ".8rem",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M326.08 670.72V64h128.96v768h-.64l-.192 128.128L64 599.296l88.064-87.68L326.08 670.72zm380.992-318.272v607.68H577.92v-788.48l.32.192.576-107.84L960 414.72l-79.68 94.976-173.248-157.248z"
  })));
};
export default SvgSort;